import React from "react";
import ComparisonTable from "./ComparisonTable";

const KeyDifferences = ({ data }) => {
    if (!data) return null;

    return (
        <div className="keyDifference">
            <h4 className="title">{data?.title}</h4>
            {data?.paragraph?.map((para, paraIndex) => {
                return (
                    <div key={paraIndex}>
                        <p className="paragraph">{para?.para}</p>
                        <ComparisonTable data={para} />
                    </div>
                )
            })}
        </div>
    );
};

export default KeyDifferences;